import { QUIZ_COMPLETE_COOKIE_NAME } from 'components/constants'
import { trackQuizCompletedWithCallback } from 'components/gtmV2'
import { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useSelector } from 'react-redux'
import { selectQuizCountry } from 'redux/quiz/slice'
import { useLocation } from 'react-router-dom'
import { cookieDomain, cookieExpiryDate } from '../screen-templates/EntryScreen'
import React from 'react'
import { getQuizRouteConfig } from '../versioned-components/v5/quizRouting'
import DEFAULT_QUIZ_CONFIG from '../../config/quiz.config'
import { appendLeadId } from 'libs/attribution'

export type ExitScreenProps = {
  exitPath: string
}

export const ExitScreen: React.FC<ExitScreenProps> = (props): null => {
  const quizCountry = useSelector(selectQuizCountry)
  const [, setCookies] = useCookies([QUIZ_COMPLETE_COOKIE_NAME])
  const location = useLocation()
  const { quizVersion } = getQuizRouteConfig(location.pathname)
  const { productType, exitPath = props.exitPath } = DEFAULT_QUIZ_CONFIG[quizVersion] ?? {}

  useEffect(() => {
    setCookies(QUIZ_COMPLETE_COOKIE_NAME, true, {
      path: '/',
      expires: cookieExpiryDate(180),
      domain: cookieDomain,
    })

    trackQuizCompletedWithCallback(quizVersion, productType, () => {
      window.location.assign(appendLeadId(exitPath))
    })
  }, [quizCountry])

  return null
}
